module.exports = {
  invoice_drawCollectInvoice: 'Xuất hóa đơn/Nhận hóa đơn',
  invoice_queryInvoice: 'Tra cứu hóa đơn',
  invoice_invoiceCategory: 'Loại hóa đơn',
  invoice_invoiceDownloadLabel: 'Tải xuống',
  invoice_electronicInvoiceDownload: 'Tải hóa đơn điện tử',
  invoice_sendEmail: 'Gửi',
  invoice_mailSend: 'Gửi email',
  invoice_sendEmailLog: 'Nhật ký',
  invoice_downloadTimes: 'Số lần tải xuống của khách hàng',
  invoice_electronicInvoiceSendStatus: 'Trạng thái gửi hóa đơn điện tử',
  invoice_download: 'Tải xuống',
  invoice_salesDepartment: 'Phòng kinh doanh',
  invoice_opDepartment: 'Phòng vận hành',
  invoice_chineseDescriptionOfGoods: 'Tên hàng hóa (tiếng Trung)',
  invoice_englishDescriptionOfGoods: 'Tên hàng hóa (tiếng Anh)',
  billingJob_taxRate: 'Thuế suất',
  invoice_hedging: 'Đối trừ',
  invoice_selectTheHedging: 'Vui lòng tra cứu và chọn để đối trừ',
  invoice_return: 'Quay lại',
  invoice_query: 'Tìm kiếm',
  invoice_invoicing: 'Xuất hóa đơn',
  invoice_collectInvoice: 'Nhận hóa đơn',
  billingJob_billDate: 'Ngày hóa đơn',
  invoice_confirm: 'Xác nhận',
  invoice_hedgingInvoice: 'Xuất hóa đơn đối trừ',
  invoice_hedgingCollectingInvoice: 'Nhận hóa đơn đối trừ',
  invoice_cancelBillConfirmation: 'Hủy xác nhận hóa đơn',
  invoice_revenueAndExpenditureMethod: 'Phương thức thanh toán:',
  invoice_all: 'Tất cả',
  invoice_convert: 'Quy đổi',
  invoice_convert_after_tax: 'Quy đổi giá chưa thuế',
  invoice_receivables: 'Phải thu',
  invoice_payables: 'Phải trả',
  invoice_feeType: 'Loại chi phí:',
  invoice_domestic: 'Nội địa',
  invoice_international: 'Nước ngoài',
  invoice_charges: 'Chi phí',
  invoice_business: 'Nghiệp vụ',
  invoice_bill: 'Hóa đơn',
  invoice_accountStatement: 'Đối chiếu hóa đơn',
  invoice_defaultInformation: 'Xuất hóa đơn theo thông tin mặc định',
  invoice_customer: 'Khách hàng',
  invoice_businessNumber: 'Mã nghiệp vụ',
  invoice_consignationCompany: 'Đơn vị ủy thác',
  invoice_settlementCompany: 'Đơn vị thanh toán',
  invoice_mblNo: 'Số vận đơn chính',
  invoice_vessel: 'Tên tàu',
  invoice_voyage: 'Chuyến bay',
  invoice_billNo: 'Số hóa đơn',
  invoice_accountStatementNo: 'Số đối chiếu hóa đơn',
  invoice_paymentApplicationNo: 'Số yêu cầu thanh toán',
  invoice_itemNo: 'Mã dự án',
  invoice_bookingNo: 'Số đặt chỗ',
  invoice_businessType: 'Loại hình nghiệp vụ',
  invoice_solicitationType: 'Loại hình nhận hàng',
  invoice_amountRange: 'Khoảng tiền',
  invoice_chargeItem: 'Tên chi phí',
  invoice_customerTypeId: 'Loại khách hàng',
  invoice_businessDate: 'Ngày nghiệp vụ',
  invoice_receivablesInvoicingDate: 'Ngày lập hóa đơn phải thu',
  invoice_currency: 'Loại tiền tệ',
  invoice_operation: 'Thao tác',
  invoice_sales: 'Bán hàng',
  invoice_cargoSalesId: 'Bán hàng nhận hàng',
  invoice_advanceMoneyForAnotherOrNot: 'Có ứng trước không',
  invoice_adjustedOrNot: 'Có điều chỉnh không',
  invoice_wroteOffOrNot: 'Đã thanh toán chưa',
  invoice_generatedBillsOrNot: 'Đã tạo hóa đơn chưa',
  invoice_invoicedOrNot: 'Đã lập hóa đơn chưa',
  invoice_appliedForPaymentOrNot: 'Đã yêu cầu thanh toán chưa',
  invoice_receivablesInvoicingStatus: 'Trạng thái hóa đơn phải thu',
  invoice_payablesInvoicingStatus: 'Trạng thái hóa đơn phải trả',
  invoice_department: 'Phòng ban',
  invoice_customerLevel: 'Cấp độ khách hàng',
  invoice_settlementMethod: 'Phương thức thanh toán',
  invoice_contactPerson: 'Người liên hệ',
  invoice_businessReferenceNumber: 'Số tham chiếu nghiệp vụ',
  invoice_invoiceHeader: 'Người nhận hóa đơn',
  invoice_inputBy: 'Người tạo hóa đơn',
  invoice_dateCreated: 'Thời gian tạo hóa đơn',
  invoice_accrued: 'Đã trích lập',
  invoice_invoicingMethod: 'Phương thức lập hóa đơn',
  invoice_businessStatus: 'Trạng thái nghiệp vụ',
  invoice_feeStatus: 'Trạng thái chi phí',
  invoice_confirmStatus: 'Trạng thái xác nhận',
  invoice_vesselAndVoyage: 'Tên tàu chuyến đi',
  invoice_portOfLoading: 'Cảng đi',
  invoice_portOfDestination: 'Cảng đến',
  invoice_financialDate: 'Ngày tài chính',
  invoice_domesticOrInternational: 'Trong nước/ngoài nước',
  invoice_paymentType: 'Loại thanh toán',
  invoice_quantity: 'Số lượng',
  invoice_taxIncludedPrice: 'Giá bao gồm thuế',
  invoice_taxExcludedPrice: 'Giá chưa bao gồm thuế',
  invoice_taxAmount: 'Số tiền thuế',
  invoice_theAmountOfWriteOffs: 'Số tiền thanh toán',
  invoice_amountNotWrittenOff: 'Số tiền chưa thanh toán',
  invoice_chargesRemarks: 'Ghi chú chi phí',
  invoice_totalAmountNotWrittenOff: 'Tổng số tiền chưa thanh toán',
  invoice_receivablesInvoicing: 'Hóa đơn phải thu',
  invoice_payablesInvoicing: 'Hóa đơn phải trả',
  invoice_payablesCollectInvoice: 'Hóa đơn phải thu',
  invoice_invoicingType: 'Loại hóa đơn',
  invoice_makeType: 'Chủng loại hóa đơn',
  invoice_invoiceStatus: 'Trạng thái hóa đơn',
  invoice_makePaper: 'Hóa đơn giấy',
  invoice_makeElectronic: 'Hóa đơn điện tử',
  invoice_consolidatedInvoice: 'Hóa đơn hợp nhất (theo nhóm đơn vị thanh toán)',
  invoice_consolidatedInvoiceCollect: 'Hóa đơn thu hợp nhất (theo nhóm đơn vị thanh toán)',
  invoice_invoicingAccordingToBusiness: 'Hóa đơn theo nghiệp vụ (theo nhóm đơn vị thanh toán)',
  invoice_invoicingAccordingToBusinessCollect: 'Hóa đơn thu theo nghiệp vụ (theo nhóm đơn vị thanh toán)',
  invoice_invoicingAccordingToRecords: 'Hóa đơn theo bản ghi (mỗi bản ghi tạo một hóa đơn)',
  invoice_invoicingAccordingToRecordsCollect: 'Hóa đơn thu theo bản ghi (mỗi bản ghi tạo một hóa đơn)',
  invoice_invoicingPerRecord: 'Mỗi bản ghi tạo một hóa đơn',
  invoice_invoiceType: 'Loại hóa đơn',
  invoice_CollectInvoiceType: 'Loại hóa đơn thu',
  invoice_invoicingAccordingToCurrency: 'Hóa đơn theo loại tiền tệ',
  invoice_invoicingAccordingToCurrencyCollect: 'Hóa đơn thu theo loại tiền tệ',
  invoice_invoicingPerCurrency: 'Tách hóa đơn theo loại tiền tệ',
  invoice_invoicingPerCurrencyCollect: 'Tách hóa đơn thu theo loại tiền tệ',
  invoice_specifyInvoiceCurrency: 'Chỉ định loại tiền tệ hóa đơn',
  invoice_consolidatedCurrency: 'Hợp nhất loại tiền tệ',
  invoice_invoicingCurrency: 'Loại tiền tệ hóa đơn',
  invoice_invoiceExchangeRate: 'Tỷ giá hóa đơn',
  invoice_invoicingCurrencyCollect: 'Loại tiền tệ hóa đơn thu',
  invoice_showChargeDetails: 'Nội dung hóa đơn hiển thị chi tiết chi phí',
  invoice_invoicingAccordingToFinancialExchangeRate: 'Hóa đơn theo tỷ giá tài chính',
  invoice_invoicingAccordingToFinancialExchangeRateCollect: 'Hóa đơn thu theo tỷ giá tài chính',
  invoice_invoicingAccordingByBillingExchangeRate: 'Hóa đơn theo tỷ giá hóa đơn',
  invoice_invoicingAccordingByBillingExchangeRateCollect: 'Hóa đơn thu theo tỷ giá hóa đơn',
  invoice_generateCostInvoice: 'Tạo hóa đơn chi phí',
  invoice_subTotal: 'Tổng phụ',
  invoice_exchangeRate: 'Tỷ giá',
  invoice_alwaysInvoicing: 'Luôn áp dụng tỷ giá này để lập hóa đơn',
  invoice_SplitChargeOnlyChangeQuantity: '"Đơn giá" không thay đổi sau khi chia, "Số lượng" cập nhật',
  invoice_total: 'Tổng cộng',
  invoice_revenueAndExpenditureType: 'Loại thu chi',
  invoice_invoicingExchangeRate: 'Tỷ giá lập hóa đơn',
  invoice_InvoicingAmount: 'Số tiền hóa đơn',
  invoice_billBusinessNo: 'Số hóa đơn/nghiệp vụ',
  invoice_billBusinessDate: 'Ngày hóa đơn/nghiệp vụ',
  invoice_accountBillBusinessDate: 'Số đối chiếu/hóa đơn/nghiệp vụ',
  invoice_paymentNotificationAndBusiness: 'Thông báo thanh toán/số nghiệp vụ',
  invoice_invoiceInformation: 'Thông tin hóa đơn',
  invoice_invoiceContent: 'Nội dung hóa đơn',
  invoice_chargeDetails: 'Chi tiết chi phí',
  invoice_unitPrice: 'Đơn giá',
  invoice_amount: 'Số tiền',
  invoice_invoiceNo: 'Số hóa đơn',
  invoice_invoiceDate: 'Ngày lập hóa đơn',
  invoice_invoicingDate: 'Ngày hóa đơn',
  invoice_bargeETD: 'Ngày khởi hành của sà lan',
  invoice_billPaymentNo: 'Số thông báo thanh toán',
  invoice_proofDate: 'Ngày chứng từ',
  invoice_writeOffStatus: 'Tình trạng đối chiếu',
  invoice_redChargesStatus: 'Tình trạng điều chỉnh (hồng)',
  invoice_printOrNot: 'Đã in hay chưa',
  invoice_invalidOrNot: 'Đã hủy hay chưa',
  invoice_exportOrNot: 'Đã xuất hay chưa',
  invoice_invoiceApplicant: 'Người yêu cầu lập hóa đơn',
  invoice_invoiceVoider: 'Người hủy hóa đơn',
  invoice_invoiceVoidTime: 'Thời gian hủy hóa đơn',
  invoice_totalCurrency: 'Tổng theo loại tiền',
  invoice_notWrittenOffTotalCurrency: 'Tổng chưa đối chiếu theo loại tiền',
  invoice_alreadyExportOrNot: 'Đã xuất hay chưa',
  invoice_havingInvoiceingNoOrNot: 'Có số hóa đơn hay không',
  invoice_exportProofFinancialOrNot: 'Đã xuất chứng từ kế toán hay chưa',
  invoice_totalAmount: 'Tổng số tiền',
  invoice_taxFreeAmount: 'Không bao gồm thuế',
  invoice_customJobType: 'Loại nghiệp vụ tùy chỉnh',
  invoice_userDefinedField1: 'Trường tùy chỉnh 1',
  invoice_userDefinedField2: 'Trường tùy chỉnh 2',
  invoice_userDefinedField3: 'Trường tùy chỉnh 3',
  invoice_userDefinedField4: 'Trường tùy chỉnh 4',
  invoice_containerNo: 'Số container',
  invoice_voyageLine: 'Tuyến đường',
  invoice_separateNumber: 'Số vận đơn phụ',
  invoice_sp1: 'Liên hóa đơn',
  invoice_sp2: 'Đơn vị thanh toán',
  invoice_sp3: 'Số hóa đơn',
  invoice_sp4: 'Xóa',
  invoice_sp5: 'Ngày lập hóa đơn',
  invoice_sp6: 'Loại tiền gốc',
  invoice_sp7: 'Loại tiền hóa đơn',
  invoice_sp8: 'Ngân hàng bên tôi',
  invoice_sp9: 'Tài khoản bên tôi',
  invoice_sp10: 'Nơi xuất phát',
  invoice_sp11: 'Cảng dỡ hàng',
  invoice_sp12: 'Điểm đến',
  invoice_sp13: 'Ngày khởi hành',
  invoice_sp14: 'Ngày đến cảng',
  invoice_sp15: 'Yêu cầu lập hóa đơn',
  invoice_sp16: 'Tên tàu và chuyến',
  invoice_sp17: 'Mở rộng chi tiết',
  invoice_sp18: 'Gộp chi tiết',
  invoice_sp19: 'Hàng hóa',
  invoice_sp20: 'Số tiền gốc',
  invoice_sp21: 'Số tiền quy đổi',
  invoice_sp22: 'Số tiền quy đổi',
  invoice_sp23: 'Ghi chú',
  invoice_sp24: 'Giải thích tài chính',
  invoice_sp25: 'Tổng số tiền',
  invoice_sp26: 'Tổng cộng',
  invoice_sp27: 'Con dấu doanh nghiệp',
  invoice_sp28: 'Kiểm tra lại',
  invoice_sp29: 'Mã số thuế',
  invoice_theLastPage: 'Trước',
  invoice_theNextPage: 'Tiếp theo',
  invoice_sp30: 'Đặt nội dung này làm thông tin hóa đơn mặc định',
  invoice_sp31: 'Phân bổ chi phí',
  invoice_back: 'Quay lại',
  invoice_selectInvoiceNo: 'Chọn số hóa đơn',
  invoice_next: 'Tiếp tục',
  invoice_invoiceConfirmation: 'Xác nhận lập hóa đơn',
  invoice_collectInvoiceConfirmation: 'Xác nhận nhận hóa đơn',
  invoice_save: 'Lưu',
  invoice_print: 'In',
  invoice_printAll: 'In tất cả',
  invoice_CATISExport: 'Xuất dữ liệu thuế',
  invoice_CATISPrint: 'In hóa đơn thuế',
  invoice_CATISInvalid: 'Hủy hóa đơn thuế',
  invoice_cancel: 'Hủy',
  invoice_close: 'Đóng',
  invoice_view: 'Xem',
  invoice_forceDelete: 'Xóa cưỡng chế',
  invoice_delete: 'Xóa',
  invoice_invalid: 'Hủy bỏ',
  invoice_exportVATInvoice: 'Xuất hóa đơn VAT',
  invoice_importVATInvoice: 'Nhập hóa đơn VAT',
  invoice_applyForPayment: 'Yêu cầu thanh toán',
  invoice_sp32: 'Xuất dữ liệu Bách Vượng',
  invoice_billPaymentState: 'Trạng thái yêu cầu thanh toán',
  invoice_downLoad: 'Tải xuống',
  invoice_BatchDownloadElectronicInvoice: 'Tải hàng loạt hóa đơn điện tử',
  invoice_UpdateInvoice: 'Sửa hóa đơn',
  invoice_ModifyInvoiceInformation: 'Sửa thông tin hóa đơn',
  invoice_recheck: 'Kiểm tra lại',
  invoice_cancelRecheck: 'Hủy kiểm tra',
  invoice_approvedStatue: 'Trạng thái kiểm tra',
  invoice_approvedBy: 'Người kiểm tra',
  invoice_dateApproved: 'Ngày kiểm tra',
  invoice_incomePayDate: 'Hạn thanh toán',
  invoice_isExtended: 'Có quá hạn không',
  invoice_incomeCostDate: 'Hạn thanh toán',
  invoice_incomeCostRange: 'Khoảng quá hạn',
  invoice_sellTitle: 'Đơn vị bán hàng',
  invoice_placeOfDelivery: 'Nơi nhận hàng',
  invoice_differenceAdjustment: 'Điều chỉnh chênh lệch',
  invoice_businessCreateDate: 'Ngày tạo nghiệp vụ',
  invoice_dateTo: 'Đến',
  invoice_lockCheckBoxDate: 'Truy vấn dữ liệu ngoài 2 năm',
  invoice_queryLotsOfData: 'Truy vấn dữ liệu ngoài 2 năm',
  invoice_invoiceDateNotEmpty: 'Ngày hóa đơn không được để trống!',
  invoice_unlockInvoiceDateQuery: 'Nếu phạm vi ngày hóa đơn được chọn lớn hơn 2 năm sẽ ảnh hưởng tốc độ tải dữ liệu, bạn có chắc muốn truy vấn dữ liệu ngoài 2 năm không?',
  invoice_businessDateNotEmpty: 'Ngày nghiệp vụ không được để trống!',
  invoice_unlockBusinessDateQuery: 'Nếu phạm vi ngày nghiệp vụ được chọn lớn hơn 2 năm sẽ ảnh hưởng tốc độ tải dữ liệu, bạn có chắc muốn truy vấn dữ liệu ngoài 2 năm không?',
  invoice_actualReceiptDate: 'Ngày nhận hóa đơn thực tế',
  invoice_targetVoucherNo: 'Số chứng từ đối tác',
  invoice_voucherDate: 'Ngày chứng từ 2',
  invoice_redPunch: 'Điều chỉnh âm (hồng xung)',
  invoice_etd: 'ETD (Ngày dự kiến khởi hành)',
  invoice_eta: 'ETA (Ngày dự kiến đến)',
  invoice_notesOnReceipt: 'Ghi chú nhận hóa đơn',
  invoice_invoiceRemarks: 'Ghi chú hóa đơn',
  invoice_settleDepartmentPrefix: 'Bộ phận thanh toán',
  invoice_denomination: 'Phân loại tiền tệ',
  lastInvoicingDate: 'Ngày xuất hóa đơn muộn nhất',
  invoice_ATD: 'ATD (Ngày thực tế khởi hành)',
  invoice_OperationTime: 'Ngày thao tác',
  invoice_updateRemark: 'Sửa ghi chú',
  OurBankAccountNo: 'Tài khoản ngân hàng bên tôi',
  OurBankCurrency: 'Loại tiền tệ ngân hàng bên tôi',
  RedChargesOrNot: 'Có điều chỉnh âm không?',
  revenueAndExpenditureType: 'Loại hình thu chi',
  InvoiceDateCreated: 'Ngày tạo hóa đơn',
  ElInvoiceSendStatus: 'Trạng thái gửi hóa đơn điện tử',
  ElInvoiceSendPlatformStatus: 'Trạng thái gửi hóa đơn điện tử lên nền tảng',
  ElInvoiceSendEmailStatus: 'Trạng thái gửi hóa đơn điện tử qua email',
  InvoicingByBusinessDateExchangeRate: 'Xuất hóa đơn theo tỷ giá ngày nghiệp vụ',
  InvoicingByBusinessDateExchangeRateCollect: 'Nhận hóa đơn theo tỷ giá ngày nghiệp vụ',
  InvoicingByBusinessDateExchangeRateTips: 'Vui lòng chọn chi phí cùng ngày nghiệp vụ để xuất hóa đơn!',
  existUnconfirmedStatus: 'Hóa đơn được chọn có trạng thái "Chưa xác nhận", bạn có muốn tiếp tục xuất hóa đơn không?',
  AutoCheckInvoicing: 'Tự động chọn xuất hóa đơn',
  AutoCheckInvoicingToolTips: 'Sau khi sử dụng, hệ thống sẽ tự động chọn số tiền hóa đơn gần hoặc bằng với số tiền cài đặt. Lưu ý: Chức năng này không tự động xuất hóa đơn, nếu cần xuất hóa đơn vui lòng thao tác thủ công.',
  DefaultInvoicingAmount: 'Số tiền xuất hóa đơn cài đặt:',
  AutoCheckInvoicingAmount: 'Tự động chọn số tiền xuất hóa đơn',
  AutoCheckInvoicingDialogToolTips: 'Tổng số tiền được chọn tự động sẽ gần hoặc bằng với số tiền cài đặt.',
  AutoSplitCharge: 'Tự động tách chi phí',
  AutoCalculateSplit: 'Tự động tính toán tách',
  AutoCalculateSplitResult: 'Kết quả tách tự động',
  IncludingTaxAmountLimit: 'GBTmax:',
  AutoCheckInvoicingSuccess: 'Thao tác hoàn tất, số tiền chi phí đã chọn quy đổi sang CNY là: {0} đồng, nếu cần chỉnh sửa vui lòng chọn điều chỉnh thủ công.',
  UseAutoCheckInvoicing: 'Chọn chi phí dựa trên số tiền xuất hóa đơn cài đặt',
  AutoAmountCanNotZero: 'Số tiền xuất hóa đơn cài đặt phải lớn hơn 0!',
  ArMoreApForAutoCheckInvoicing: 'Thao tác hoàn tất, số tiền phải trả được chọn tự động lớn hơn số tiền phải thu, xuất hóa đơn trực tiếp sẽ được tính là nhận hóa đơn, đề nghị điều chỉnh thủ công.',
  invoice_invoicingAccordingToSettlementAgent: 'Gộp xuất hóa đơn (Xuất hóa đơn theo nhóm đại lý thanh toán)',
  invoice_invoicingAccordingToSettlementAgentCollect: 'Gộp nhận hóa đơn (Nhận hóa đơn theo nhóm đại lý thanh toán)',
  invoice_invoicingAccordingToTitle: 'Xuất hóa đơn theo tên (Mỗi tên hóa đơn tạo một hóa đơn)',
  invoice_invoicingAccordingToTitleCollect: 'Thu hóa đơn theo tên (Mỗi tên hóa đơn tạo một hóa đơn)',
  RequestTaxControlPlatformStatus: 'Yêu cầu nền tảng kiểm soát thuế có thành công không',
  GetInvoiceNumber: 'Lấy số hóa đơn',
  NotDoInvoice: 'Chưa xuất hóa đơn trên Cloud Tax, vui lòng xuất hóa đơn trước',
  GetInvoiceNoSuccess: 'Đang lấy số hóa đơn, vui lòng kiểm tra sau!',
  GetInvoiceNoFail: 'Lấy số hóa đơn thất bại!',
  NotDoInvoiceBwjsy: 'Chưa lập hóa đơn trên Baiwang Jinsui Cloud, vui lòng lập hóa đơn trước!',
  GetInvoiceNoSuccessBwjsy: 'Lấy số hóa đơn thành công!',
  GetInvoiceNoFailPart: 'Một số số hóa đơn lấy không thành công, vui lòng thử lại sau!',
  NotInvoice: 'Chưa lập hóa đơn, vui lòng lập hóa đơn trước',
  PaperTicketPrinting: 'In hóa đơn giấy',
  NameOfSeller: 'Tên đơn vị bán hàng',
  CNYReceived: 'Đã thu tương đương CNY',
  CNYNotReceived: 'Chưa thu tương đương CNY',
  CNYPaid: 'Đã thanh toán tương đương CNY',
  CNYNotPaid: 'Chưa thanh toán tương đương CNY',
  InvoiceNoImport: 'Nhập số hóa đơn',
  SpecificConstraintTypes: 'Loại ràng buộc cụ thể',
  PurchaserInformation: 'Thông tin bên mua',
  SellerInformation: 'Thông tin bên bán',
  TypeOfTransport: 'Loại phương tiện vận chuyển',
  TransportVehicleBrand: 'Biển số phương tiện vận chuyển',
  Origin: 'Điểm xuất phát',
  Destination: 'Điểm đến',
  NameOfGoodsTransported: 'Tên hàng hóa vận chuyển',
  ServiceOfGoodsTransported: 'Dịch vụ vận chuyển hàng hóa',
  FeiRedApplicationStatus: 'Trạng thái yêu cầu hóa đơn điện tử màu đỏ',
  RedFlushReason: 'Lý do điều chỉnh hóa đơn đỏ',
  RedApplyFail: 'Yêu cầu hóa đơn đỏ thất bại, vui lòng kiểm tra nguyên nhân.',
  RedApplying: 'Yêu cầu hóa đơn đỏ đã gửi, vui lòng chờ thành công trước khi thực hiện thao tác "xuất Golden Tax".',
  BatchCheckNotRedStatus: 'Chỉ hỗ trợ thao tác với hóa đơn ở trạng thái điều chỉnh, vui lòng chọn lại và hoàn tất.',
  BatchCheckNotRedApplyInvoice: 'Chỉ hỗ trợ thao tác với hóa đơn chưa yêu cầu hoặc yêu cầu thất bại, vui lòng chọn lại và hoàn tất.',
  BatchCheckRedApplySuccessInvoice: 'Chỉ hỗ trợ thao tác với hóa đơn yêu cầu thành công, vui lòng chọn lại và hoàn tất.',
  BatchCheckRedFlushInvoice: 'Chỉ hỗ trợ thao tác hàng loạt với hóa đơn cùng trạng thái, vui lòng chọn lại và hoàn tất.',
  BatchCheckRedFlushInvoiceType: 'Chỉ hỗ trợ thao tác hàng loạt với hóa đơn điện tử, vui lòng chọn lại và hoàn tất.',
  BatchCheckRedFlushInvoiceTipOne: 'Đã chọn',
  BatchCheckRedFlushInvoiceTipTwo: 'Hóa đơn sẽ được điều chỉnh',
  IncorrectInvoicing: 'Lập hóa đơn sai',
  SalesReturn: 'Hàng trả lại',
  ServiceTermination: 'Dịch vụ chấm dứt',
  SalesAllowance: 'Giảm giá bán',
  AllElectricInvoicing: 'Lập hóa đơn điện tử',
  RealPersonAuth: 'Xác thực danh tính đã hết hạn',
  PersonAuth: 'Xác thực danh tính',
  WeChatScanningAgain: 'Vui lòng mở ứng dụng thuế, giao diện đăng nhập, nghiệp vụ cá nhân, đăng nhập bằng khuôn mặt, nhập tài khoản (số điện thoại) rồi quét mặt để đăng nhập, sau khi thành công có thể quét mã để hoàn tất xác thực.',
  Certified: 'Đã xác thực',
  QdWarningTip: 'Cục Thuế Nhà nước đang điều chỉnh khẩn cấp giao diện lập hóa đơn điện tử, hiện lập trình viên đang làm việc khẩn trương, trong thời gian nâng cấp vui lòng thực hiện thao tác lập hóa đơn trên trang web thuế quốc gia, xin cảm ơn sự thông cảm của bạn.',
  FailureDescription: 'Hướng dẫn yêu cầu nền tảng kiểm soát thuế',
  SelectRightInvoice: 'Vui lòng chọn hóa đơn đủ điều kiện!',
  ApplyRed: 'Yêu cầu hóa đơn đỏ',
  CancelApplyRed: 'Hủy yêu cầu hóa đơn đỏ',
  InvoiceNotSyncOrInvalid: 'Hóa đơn chưa đồng bộ hoặc đã hủy, không thể điều chỉnh!',
  CloudStarrySkyNotSync: 'Chưa đồng bộ Cloud Sky, không thể hủy, vui lòng đồng bộ trước!',
  VoidedSuccessfully: 'Hủy thành công',
  RateChangedTip: 'Tỷ giá ngày hóa đơn thay đổi, có cập nhật tỷ giá hóa đơn không?',
  RateChangedSuccess: '，Cập nhật tỷ giá hối đoái thành công！',
  SelectReasonForRedOffsetInvoice: 'Vui lòng chọn lý do hủy hóa đơn',
  OnlyMaster: 'Chỉ hóa đơn chính',
  invoice_chargeCurrencyRate1: 'Tỷ giá loại tiền 1',
  invoice_chargeCurrencyRate2: 'Tỷ giá loại tiền 2',
  GetInvoiceNumberVietnam: 'Tra cứu số hóa đơn Việt Nam',
  GetInvoicePdfVietnam: 'Tải xuống hóa đơn Việt Nam',
  GetInvoiceStateVietnam: 'Kiểm tra trạng thái hóa đơn Việt Nam',
  PaymentMethodVietnam: 'Phương thức thanh toán Việt Nam',
  InvoiceStateVietnam: 'Trạng thái hóa đơn Việt Nam',
  PleaseThanOneInvoiceMerge: 'Vui lòng chọn từ hai hóa đơn trở lên để hợp nhất',
  Verification: 'Xác minh',
  InvoiceDocument: 'tài liệu hóa đơn',
  Missing: 'Vắng mặt',
  StartingPleaseWaitForEmail: 'Bắt đầu thực hiện hợp nhất hóa đơn. Vui lòng chờ email kết quả.',
  NoExistsInTheData: 'Không có tệp hóa đơn nào trong dữ liệu đã chọn!'
}
